import { TLists } from "./types"
import "./styles.scss"
import { ContentSectionContainer, fetchRoute } from "@cakemail-org/ui-components-v2"
import { ListsContext } from "./context"
import { Route, Routes } from "react-router-dom"
import { ERoutes } from "../../utils/url"
import ListsListing from "./containers/listing"

export function Lists({ }: TLists) {
    return <ContentSectionContainer className="listsContainer">
        <ListsContext.Provider value={{}}>
            <Routes>

                <Route index path={fetchRoute({ route: ERoutes.lists })} element={<ListsListing />} />

                <Route index path={"/"} element={<ListsListing />} />

            </Routes>
        </ListsContext.Provider>
    </ContentSectionContainer>
}